import * as roteiro from '@/api/roteiro'
import { convertSelect } from '../../../service/collection'

const state = {
  list: [],
  listaSelect: [],
  filtros: {page: 1},
  countPage: 0,
  modalAdd: false,
  modalEdit: false,
  modalConfDel: false
}

const mutations = {
  SETROTEIROS (state, payload) {
    state.list = payload.list
  },
  SETROTEIROSSELECT (state, payload) {
    state.listaSelect = convertSelect(payload.list)
  },
  MODALADD (state, payload) {
    state.modalAdd = payload
  },
  MODALEDIT (state, payload) {
    state.modalEdit = payload
  },
  MODALCONFDEL (state, payload) {
    state.modalConfDel = payload
  },
  SETPAGE (state, payload) {
    state.filtros.page = payload
  },
  SETPAGINATE (state, payload) {
    if (payload === 1) state.countPage = 0
    else state.countPage = payload
  },
  SETFILTROS (state, payload) {
    if (payload) {
      state.filtros = payload
    }
  }
}

const actions = {
  modalAdd: function ({ commit }, payload) {
    commit('MODALADD', payload)
  },
  modalEdit: function ({ commit }, payload) {
    commit('MODALEDIT', payload)
  },
  modalConfDel: function ({ commit }, payload) {
    commit('MODALCONFDEL', payload)
  },
  async get ({ commit }, payload) {
    let data = await roteiro.get(payload)
    return data
  },
  async getRoteiros ({ commit }, payload) {
    commit('SETFILTROS', payload)
    let data = await roteiro.getRoteiros(payload)
    commit('SETROTEIROS', data)
    commit('SETPAGINATE', data.pages)
  },
  async getRoteirosDash ({ commit }, payload) {
    return roteiro.getRoteirosDash(payload)
  },
  async getRoteirosFiltro ({ commit }) {
    let data = await roteiro.getRoteiros(state.filtros)
    commit('SETROTEIROS', data)
  },
  async getRoteirosSelect ({ commit }, payload) {
    let data = await roteiro.roteirosSelect()
    commit('SETROTEIROSSELECT', data)
  },
  async add ({ commit }, payload) {
    try {
      payload.instituicao.id = payload.instituicao.value
      payload.produto.id = payload.produto.value
      return roteiro.add(payload)
    } catch (e) {
      return e
    }
  },
  async edit ({ commit }, payload) {
    if (payload.instituicao) {
      payload.instituicao.id = payload.instituicao.value
    }
    if (payload.produto) {
      payload.produto.id = payload.produto.value
    }
    try {
      await roteiro.edit(payload)
      return true
    } catch (e) {
      return e
    }
  },
  async del ({ commit }, payload) {
    try {
      let retorno = await roteiro.del(payload)
      return retorno
    } catch (e) {
      return e
    }
  },
  setPage (context, payload) {
    context.commit('SETPAGE', payload)
    context.dispatch('getRoteiros', state.filtros)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/roteiro.js